var map = {
	"./apple.svg": 546,
	"./fliq_type_icon.svg": 8743,
	"./home/artist_bg.svg": 2895,
	"./home/ic_app_store.svg": 7272,
	"./home/ic_play_store.svg": 3701,
	"./home/ic_qrcode.svg": 7815,
	"./ic_appstore.svg": 7885,
	"./ic_bts.svg": 1574,
	"./ic_camera.svg": 876,
	"./ic_check.svg": 3831,
	"./ic_check_red.svg": 7687,
	"./ic_close.svg": 8715,
	"./ic_download.svg": 3757,
	"./ic_edit.svg": 7653,
	"./ic_fb.svg": 3997,
	"./ic_fliqed.svg": 2822,
	"./ic_full_logo.svg": 3228,
	"./ic_gift.svg": 4111,
	"./ic_google.svg": 9276,
	"./ic_heart.svg": 7059,
	"./ic_instagram.svg": 2959,
	"./ic_left.svg": 3070,
	"./ic_linkedin.svg": 7467,
	"./ic_logo.svg": 9804,
	"./ic_menu.svg": 5692,
	"./ic_money.svg": 5203,
	"./ic_more.svg": 7690,
	"./ic_music.svg": 9650,
	"./ic_mute.svg": 4190,
	"./ic_next.svg": 3550,
	"./ic_pause.svg": 4609,
	"./ic_pause_bottom.svg": 6717,
	"./ic_pause_mobile.svg": 4842,
	"./ic_phone.svg": 1779,
	"./ic_placeholder_content.svg": 2766,
	"./ic_play_bottom.svg": 6611,
	"./ic_play_circle.svg": 14,
	"./ic_play_mobile.svg": 1100,
	"./ic_play_show.svg": 8621,
	"./ic_play_website.svg": 8229,
	"./ic_playstore.svg": 358,
	"./ic_prev.svg": 4466,
	"./ic_sad.svg": 3943,
	"./ic_share.svg": 1630,
	"./ic_signal.svg": 4153,
	"./ic_success.svg": 2706,
	"./ic_ticket.svg": 1361,
	"./ic_unlock.svg": 3281,
	"./ic_user.svg": 4856,
	"./ic_verified.svg": 917,
	"./ic_verified_txt.svg": 8000,
	"./ic_volume.svg": 7359,
	"./instagram.svg": 9193,
	"./powered_img.svg": 3970,
	"./spotify.svg": 2740,
	"./tiktok.svg": 2088,
	"./white_logo.svg": 7781,
	"./x.svg": 698,
	"./youtube.svg": 8549
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1980;